import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// 🔐 Log what's being used
console.log("🔥 Firebase project:", firebaseConfig.projectId);

// Make sure we don't double-initialize
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Only run analytics in browser (avoid SSR errors)
let analytics = null;
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) {
      analytics = getAnalytics(app);
    }
  });
}

const db = getFirestore(app);
const functions = getFunctions(app);
const auth = getAuth(app);

// Local emulators
if (process.env.REACT_APP_IS_LOCAL === "1") {
  console.log("🧪 Connecting to Firebase emulators...");
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
}

export { app, db, auth, functions, analytics };